export const DataKeys: Record<string, string> = {
  OpenSearch: 'open-search',
  CloseSearch: 'close-search',
  PrimaryNav: 'primary-nav',
  Logo: 'logo',
  MobileNavTrigger: 'mobile-nav-trigger',
  SkipLink: 'skip-link',
  BackLink: 'back-link',
  CloseButton: 'close-button',
  UserIcon: 'user-icon',
  IconNav: 'icon-nav',
  SideNavigation: 'side-navigation',
  SecondarySideNavigation: 'secondary-side-navigation',
  TopBar: 'top-bar',
}
